import PrivacyPolicy from "@/views/public/legal/PrivacyPolicy.vue";

export default {
  path: "/privacy",
  name: "privacy",
  component: PrivacyPolicy
};
